module.exports = __webpack_public_path__ + "img/user.49b70ef6.svg";